module.exports = __webpack_public_path__ + "static/media/enginer.4849d161.svg";